(function () {
    'use strict';
    var controllerId = 'domAdesAssign';

    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'sectionMenu', 'cpi', 'cpiId', 'isSuper', domAdesAssign]);

    function domAdesAssign($scope, $uibModalInstance, datacontext, sectionMenu, cpi, cpiId, isSuper) {
        $scope.domAdes = {};
        $scope.retVal = {};
        $scope.cpi = cpi;
        $scope.cpiId = cpiId;
        $scope.isSuper = isSuper;

        
        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };


        //Parametro aziendaId utilizzato per impostare e bloccare selezione Azienda
        //Utilizzato in caso di creazione unovo domAdes da view /app/RUBRICA/azienda/aziendaDetail.html
        if (cpiId) {
            $scope.cpiId = cpiId;
            $scope.domAdes.CPIId = cpiId;
        }     

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.assign = function (cf, cpiId) {
            return datacontext.CNDAdesione_assign(cf, cpiId).then(function (data) {
                if (!data) return null;
                var result = {};
                result.status = "assign";
                result.data = {};
                result.data.Id = data; //domAdesId
                $uibModalInstance.close(result);
            });
        };

        $scope.statusCF = 0;
        $scope.searchCF = function (cf, cpiId) {
            var requiredLen = 16;
            $scope.statusCF = 0;
            if (cf == undefined) return;
            if (cf.length != requiredLen) return; //numero minimo di caratteri

            return datacontext.CNDAdesione_statusCF(cf, cpiId).then(function (data) {
                $scope.retVal = {};

                $scope.retVal.CF = cf;
                $scope.retVal.statusCF = '';
                $scope.retVal.collocamentoId = 0;
                if (data != null) {

                    var len = data.length;
                    if (len >= 2)
                        $scope.retVal.statusCF = data.substring(0, 2);
                    if (len > 2)
                        $scope.retVal.collocamentoId = data.substring(2, len);

                }

                $scope.statusCF = $scope.retVal.statusCF;
            });

        };

    }
})();